import { notificationsActions } from './notifications.actions';
import { NotificationSpecification } from '../../types/models';

export const addNotification = (notification: NotificationSpecification) => notificationsActions.addNotification(notification);

export const dismissNotification = (key: string | number) => notificationsActions.dismissNotification(key);
